import { t } from '../../common/translations';
import { MODAL_ID } from './constants';
import arrowGreySrc from 'images/icons/arrow-grey.svg';
import arrowWhiteSrc from 'images/icons/arrow-white.svg';
import questionSrc from 'images/icons/question.svg';
import calendarChecked from 'images/icons/calendar-checked.svg';
import arrowDown from 'images/icons/arrow-down.svg';
import checkIcon from 'images/icons/check-icon.svg';
import closeIcon from 'images/react_icons/xmark.svg';

export const template = () => `
<div class="modal micromodal-slide mobile-calendar-modal" style="display:none;" id="${MODAL_ID}" aria-hidden="true">
  <div class="modal__overlay" id="dates_modal_body" tabindex="-1" data-micromodal-close>
    <div class="modal__container availability-modal" role="dialog" aria-modal="true" aria-labelledby="modal-calendar-title">
      <header class="modal__header">
        <button class="modal__close" id="close-calendar-modal" aria-label="Close modal" autofocus="false"></button>
        <div class="calendar-range__selections">
          <div data-test-id="check-in-tab" id="check-in-tab" class="calendar-range__selection calendar-range__selection--selectable availability-modal-check-in-bt">
            <div class="calendar-range__selection-label">
              <span class="select_check_in">${t('apartment_page.js.modal.select')}</span>
            </div>
            <div class="calendar-range__selection-value">
              <span class="check_in selected">${t('apartment_page.js.modal.check_in')}</span>
            </div>
            <div class="calendar-range__selection-value-check_in display-none availability-modal-check-in-value">
              <span class="value_check_in"></span>
            </div>
          </div>
          <div data-test-id="check-out-tab" id="check-out-tab" class="calendar-range__selection availability-modal-check-out-bt">
            <div class="calendar-range__selection-label">
              <span  class="select_check_out">${t('apartment_page.js.modal.select')}</span>
            </div>
            <div class="calendar-range__selection-value">
              <span class="check_out">${t('apartment_page.js.modal.check_out')}</span>
            </div>
            <div class="calendar-range__selection-value-check_out display-none availability-modal-check-out-value">
              <span class="value_check_out"></span>
            </div>
          </div>
        </div>
      </header>
      <main class="modal__content mobile-calendar-modal__content" id="modal-calendar-content">
        <div class="check-in-container availability-modal-check-in">
          <input id="mobile-checkin-date"/>
        </div>
        <div class="check-out-container availability-modal-check-out">
          <input id="mobile-checkout-date"/>
        </div>
      </main>
      <div class="property-booking-bar">
        <div class="property-booking-bar__messages display-none"></div>
        <div class="property-booking-bar__content">
          <span class="clear-dates fw-bold">${t('apartment_page.js.modal.clear_filters')}</span>
          <div class="submit-wrapper display-none">
            <button id="reservation-confirm__submit" type="submit" class="btn btn-lg btn-tabas-filter btn-tabas-dark-grey text-white fs-6 py-0" disabled>
              <span class="submit_button_text"> ${t('apartment_page.js.modal.confirm_dates')}</span>
                <span data-loader="true" class="icon-s loader-icon icon-right" style="display: none">
                <img class="breakdown__total-amount-bookmark" src="${arrowWhiteSrc}">
                <span class="loader"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal__overlay display-none poppins-font" id="preview_modal_body" tabindex="-1" data-micromodal-close>
    <div class="modal__container review-rent-modal" role="dialog" aria-modal="true" aria-labelledby="modal-preview_dates-title">
      <main class="modal__content reservation-form__breakdown mobile-preview_dates-modal__content d-flex flex-column" id="modal-preview_dates-content">
        <div class="breakdown__header d-flex justify-content-between form-title">
          <div class="d-flex flex-column">
            <div>
              <span class="monthly-original-price text-decoration-line-through"></span>
            </div>
            <div>
              <span class="monthly-price"></span>
              <span class="monthly-price__period">${t('property_card.by_month')}</span>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-between align-items-end fs-7">
            <div class="breakdown__header-close-modal">
              <img src="${closeIcon}">
            </div>
            <div>
              <span class="fw-bold">${t('apartment_page.reservation_form.available_from')}
                <span class="property-available fw-normal"></span>
              </span>
            </div>
          </div>
        </div>
        <div class="dates-chosen">
          <img class="breakdown__icon calendar-icon" src="${calendarChecked}">
          <span class="date__span date__span-ini_date"></span>
          <img class="breakdown__icon arrow-icon" src="${arrowGreySrc}">
          <span class="date__span date__span-end_date"></span>
          <img class="breakdown__icon arrow-down-icon" src="${arrowDown}">
        </div>
        <div class="breakdown__title">
          <span>${t('apartment_page.reservation_form.breakdown.quote_summary')}</span>
          <div class="breakdown__title-days">
            31 Nights at
          </div>
        </div>
        <div class="breakdown__line breakdown__price">
          <div class="breakdown__label">
            <span id="first_month_label">${t('apartment_page.reservation_form.breakdown.first_month_rent')}</span>
            <span data-tippy-content="${t('breakdown.tooltip.rent')}" data-tippy-theme="tabas" class="breakdown__icon-wrapper">
              <img class="breakdown__icon question-icon" src="${questionSrc}">
            </span>
          </div>
          <div class="breakdown__value breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div style="display:none" class="breakdown__line breakdown__long_term_discount">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.long_term_discount')}</span>
          </div>
          <div class="breakdown__value breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div class="breakdown__line breakdown__cleaning_fee">
          <div class="breakdown__label">
            <span> ${t('apartment_page.reservation_form.breakdown.cleaning_fee_label')}</span>
            <span id="cleaning-tooltip-container">
              <span data-tippy-content="" data-tippy-theme="tabas" class="breakdown__icon-wrapper cleaning-fee-tooltip">
                <img class="breakdown__icon question-icon" src="${questionSrc}">
              </span>
           </span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div class="breakdown__line breakdown__deposit">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.deposit_amount_label')}</span>
            <span data-tippy-content="${t('breakdown.tooltip.deposit')}" data-tippy-theme="tabas" class="breakdown__icon-wrapper">
              <img class="breakdown__icon question-icon" src="${questionSrc}">
            </span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div class="breakdown__line breakdown__final_cleaning_fee">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.final_cleaning_fee_label')}</span>
            <span data-tippy-content="${t('breakdown.tooltip.final_cleaning_fee')}" data-tippy-theme="tabas" class="breakdown__icon-wrapper">
              <img class="breakdown__icon question-icon" src="${questionSrc}">
            </span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div class="breakdown__line breakdown__fire_insurance">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.fire_insurance_label')}</span>
            <span data-tippy-content="${t('breakdown.tooltip.fire_insurance')}" data-tippy-theme="tabas" class="breakdown__icon-wrapper">
              <img class="breakdown__icon question-icon" src="${questionSrc}">
            </span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div id="condominium" class="breakdown__line breakdown__condominium">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.condominium_label')}</span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>

        <div id="iptu" class="breakdown__line breakdown__iptu">
          <div class="breakdown__label">
            <span>${t('apartment_page.reservation_form.breakdown.iptu_label')}</span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>


        <div id='moving-with-pet-check-box-container' class='breakdown__line breakdown__moving_with_pet modal-form-check' style="justify-content:flex-start; gap: 8px">
          <input id='will-moving-with-pet' type='checkbox' class='form-check-input cursor-pointer' style="width: 1em !important; height: 1em !important" />
          <label for='will-moving-with-pet' class='form-check-label' style="opacity: 1; font-size: 1rem">
          ${t('apartment_page.reservation_form.breakdown.will_moving_with_pet')}
          </label>
        </div>

        <div class="breakdown__line breakdown__pet_fee">
          <div class="breakdown__label">
            <span style="color: #ACAEAF">${t('apartment_page.reservation_form.breakdown.pet_fee_label')}</span>
            <span data-tippy-content="${t('breakdown.tooltip.pet_fee')}" data-tippy-theme="tabas" class="breakdown__icon-wrapper">
              <img class="breakdown__icon question-icon" src="${questionSrc}">
            </span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount" style="color: #ACAEAF">
              R$ 0
            </span>
          </div>
        </div>

        <div class="breakdown__line breakdown__due-today">
          <div class="breakdown__label">
            <span id="due-today-label" class="due-today"></span>
          </div>
          <div class="breakdown__value">
            <span class="breakdown__value-amount">
              R$ 0
            </span>
          </div>
        </div>
        <div class="scheduled-payments scheduled-payments--hidden">
          <a href="#" class="scheduled-payments__button-mobile" data-bs-toggle="modal" data-bs-target="#schedule-payments-modal">${t('apartment_page.reservation_form.scheduled_payments.button')}</a>
        </div>

        <div class="breakdown__payment-types breakdown__payment-types--hidden flex-column">
          <div id="pay-in-advance" class="type-item type-item-advance d-flex flex-row justify-content-between">
            <div class="d-flex flex-row align-items-center justify-content-center">
              <div class="d-flex justify-content-center type-item-selection">
                <img src="${checkIcon}">
              </div>
              <div id="pay-in-advance-labels" class="d-flex flex-column">
                <span class="title">${t('apartment_page.reservation_form.breakdown.pay_in_advance')}</span>
                <span class="subtitle"></span>
              </div>
            </div>
            <div id="pay-in-advance-values" class="d-flex flex-column align-items-end">
              <div class="d-flex flex-column flex-md-row align-items-end align-items-md-center">
                <span class="discount-title"></span>
                <span class="title text-nowrap"></span>
              </div>
              <span class="subtitle"></span>
            </div>
          </div>
          <div id="pay-monthly" class="type-item type-item-monthly d-flex flex-row justify-content-between">
            <div class="d-flex flex-row align-items-center justify-content-center">
              <div class="d-flex justify-content-center type-item-selection">
                <img src="${checkIcon}">
              </div>
              <div id="pay-monthly-labels" class="d-flex flex-column">
                <span class="title">${t('apartment_page.reservation_form.breakdown.pay_monthly')}</span>
                <span class="subtitle"></span>
              </div>
            </div>
            <div id="pay-monthly-values" class="d-flex flex-column align-items-end">
              <span class="title"></span>
              <span class="subtitle"></span>
            </div>
          </div>
        </div>
      </main>
      <div>
        <div class="property-booking-bar p-0 mt-auto">
          <div class="reservation-form__cta">
            <div class="d-flex align-items-center justify-content-evenly m-0">
              <div class="d-md-block d-none fs-8">
                ${t('apartment_page.reservation_form.wont_charge')}
              </div>
              <div>
                <button class="fs-7 poppins-font bg-white text-color-main sticky-contact-us-clickable-in-modal border-0 contact-us-bt-modal" data-bs-toggle="modal" data-bs-target="#contactUsMobileModalFromJS">
                  <div class="sticky-contact-us-clickable-in-modal max-w-px-sm-300 text-center mx-auto">${t('apartment_page.reservation_form.contact_us')}</div>
                </button>
              </div>
              <div>
                <button id="reservation-form-mobile__submit" type="submit" class="fs-7 poppins-font bg-color-main text-color-white border-0 request-to-rent-bt px-4 py-2 rounded">
                  <span class="mx-auto"> ${t('apartment_page.reservation_form.submit')}</span>
                  <span data-loader="true" class="icon-s loader-icon icon-right" style="display: none">
                    <span class="loader"></span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
